import { MENU_CONF } from './AppBarMenu.constants';
import { MenuConf, MenuItem } from './AppBarMenu.types';

export function transformToMenu(menuConfiguration: MenuConf[]): MenuItem[] {
  const menus = menuConfiguration.reduce<MenuItem[]>(
    (
      acc,
      {
        nav,
        permission = true,
        submenus = [],
        expandIfAlone = false,
        isExternal = false,
        isDisabled = false,
        toolTip,
      },
    ) => {
      if (!permission) {
        return acc;
      }

      const adaptedSubMenu = submenus.length ? transformToMenu(submenus) : [];

      const menu = MENU_CONF[nav];

      const transformedMenu =
        adaptedSubMenu.length === 1
          ? {
              ...adaptedSubMenu[0],
              expandIfAlone,
              isExternal,
              icon: menu.icon,
            }
          : {
              expandIfAlone,
              isExternal,
              submenus: adaptedSubMenu,
              to: adaptedSubMenu.length > 0 ? adaptedSubMenu[0].to : menu.url,
              path:
                adaptedSubMenu.length > 0 ? adaptedSubMenu[0].path : menu.path,
              message: menu.message,
              icon: menu.icon,
              subCount: adaptedSubMenu.reduce(
                (acc, { count }) => count + acc,
                0,
              ),
              dataTestId: nav,
              isDisabled: isDisabled,
              toolTip,
            };

      return [...acc, transformedMenu] as MenuItem[];
    },
    [],
  );

  const smartMenuCount = menus.filter(
    ({ expandIfAlone }) => expandIfAlone,
  ).length;

  return menus.reduce<MenuItem[]>((acc, menu) => {
    if (
      menu.expandIfAlone &&
      smartMenuCount === 1 &&
      menu.submenus.length > 0
    ) {
      return [...acc, ...menu.submenus];
    }

    return [...acc, menu];
  }, []);
}
